module.exports = __webpack_public_path__ + "img/why1.228336af.svg";